export interface InsurerConfig {
  id: string;
  name: string;
  config: any;
}
